import React from 'react';
import Zinrelo from './Loadable';

function Card()
{
    return <Zinrelo />;
}

export default Card;
